import { useEffect, useState } from 'react';
import { Flex, useBreakpointValue } from '@chakra-ui/react';

import { formatPrice } from '../../../utils/format';
import DataTableSearch from './DataTableSearch';
import DataTableTable from './DataTableTable';
import DataTableCards from './DataTableCards';
import DataTablePaginate from './DataTablePaginate';

type TotalsData = {
	custo: string;
	entrega: string;
	troco: string;
};
type EntregaData = {
	id_entrega: number;
	id_loja: number;
	id_venda: number;
	id_entregador: number;
	nome_entregador: string;
	nome_cliente: string;
	tipo_venda: string;
	data_venda: string;
	data_entrega: string;
	data_previsao: string;
	atraso: string;
	tempo: string;
	obs_entrega: string;
	pago: string;
	evento: string;
	motivo: string;
	vlr_custo: number;
	vlr_entrega: number;
	vlr_troco: number;
	vlr_total: number;
	vlr_custoFormatted: string;
	vlr_entregaFormatted: string;
	vlr_trocoFormatted: string;
	vlr_totalFormatted: string;
};
interface DataTableEntregasParams {
  data: EntregaData[];
	setEntregaModal: (entrega: EntregaData) => void;
	setModalEntregaVisible: (visible: boolean) => void;
}

const DataTableEntregas: React.FC<DataTableEntregasParams> = ({ 
	data,
	setEntregaModal,
	setModalEntregaVisible,
 }) => {
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const [loading, setLoading] = useState(true);

  const [pesqEntregas, setPesqEntregas] = useState<EntregaData[]>(data);
  const [entregas, setEntregas] = useState<EntregaData[]>(data);
	const [totals, setTotals] = useState<TotalsData>({} as TotalsData);

  const [sort, setSort] = useState({ por: '', cres: true });

  const [controls, setControls] = useState({
    page: 1,
    perPage: 10,
    totalPage: Math.ceil(data.length / 10),
  });

  useEffect(() => {
		const auxTotais = { custo: 0, entrega: 0, troco: 0 };
		data.map(item => {
			auxTotais.custo += item.vlr_custo;
			auxTotais.entrega += item.vlr_entrega;
			auxTotais.troco += item.vlr_troco;
			return item;
		});
		// setTotais(auxTotais);
		setTotals({
			custo: formatPrice(auxTotais.custo),
			entrega: formatPrice(auxTotais.entrega),
			troco: formatPrice(auxTotais.troco),
		});

		setEntregas(data.slice(0, 10));
    setLoading(false);
  }, []);

  async function handleUpdateList(
    page: number,
    perPage: number,
		entregas: EntregaData[],
  ) {
    const auxPage = page - 1;
    const start = auxPage * perPage;
    const end = start + perPage;

		setEntregas(entregas.slice(start, end));
  }

  return (
    <Flex w="100%" flexDir="column" my={6}>
      <DataTableSearch
        entregas={data}
        setPesqEntregas={setPesqEntregas}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />

      {isWideVersion && (
        <DataTableTable
          entregas={entregas}
          pesqEntregas={pesqEntregas}
					totals={totals}
          sort={sort}
          setSort={setSort}
          controls={controls}
          handleUpdateList={handleUpdateList}
					setEntregaModal={setEntregaModal}
					setModalEntregaVisible={setModalEntregaVisible}
        />
      )}

      {!isWideVersion && !loading && (
				<DataTableCards
					entregas={entregas}
					pesqEntregas={pesqEntregas}
					totals={totals}
					sort={sort}
					setSort={setSort}
					controls={controls}
					handleUpdateList={handleUpdateList}
					setEntregaModal={setEntregaModal}
					setModalEntregaVisible={setModalEntregaVisible}
				/>
			)}

      <DataTablePaginate
        entregas_length={data.length}
        pesq_length={pesqEntregas.length}
        pesqEntregas={pesqEntregas}
        controls={controls}
        setControls={setControls}
        handleUpdateList={handleUpdateList}
      />
    </Flex>
  );
};

export default DataTableEntregas;
